import type { PropsWithChildren, FunctionComponent } from 'react'
import { useMemo } from 'react'
import { QualityScorecardsProvider } from '@retailer-platform/domain-quality-scorecards'
import { useCurrentAccountDetails } from '../../api/current-account/currentAccount.hooks'
import { ErrorPage } from '../../gin-and-tonic/containers/error-page/ErrorPage'
import { ICPlatformProvider } from '../ic-platform/icPlatform.context'
import { AccountLocaleSync } from './AccountLocaleSync'
import { CurrentAccountContext } from './CurrentAccountContext'

export const CurrentAccountProvider: FunctionComponent<PropsWithChildren<unknown>> = ({
  children,
}) => {
  const { error, loading, account, refetch } = useCurrentAccountDetails()

  const contextValue = useMemo(
    () => ({
      account,
      refetch,
    }),
    [account, refetch]
  )

  if (loading) return null

  if (error) return <ErrorPage />

  return (
    <CurrentAccountContext.Provider value={contextValue}>
      {/* Sync the user's locale from their account data to the I18n context */}
      <AccountLocaleSync />
      <ICPlatformProvider>
        <QualityScorecardsProvider>{children}</QualityScorecardsProvider>
      </ICPlatformProvider>
    </CurrentAccountContext.Provider>
  )
}
